[
  {
    "code": "BO-H",
    "name": "Chuquisaca"
  },
  {
    "code": "BO-C",
    "name": "Cochabamba"
  },
  {
    "code": "BO-B",
    "name": "El Beni"
  },
  {
    "code": "BO-L",
    "name": "La Paz"
  },
  {
    "code": "BO-O",
    "name": "Oruro"
  },
  {
    "code": "BO-N",
    "name": "Pando"
  },
  {
    "code": "BO-P",
    "name": "Potosí"
  },
  {
    "code": "BO-S",
    "name": "Santa Cruz"
  },
  {
    "code": "BO-T",
    "name": "Tarija"
  }
]